import axios from 'axios';
import { imgUrl, url } from 'utils/url';

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    'Content-Type': 'application/json',
  },
});

const unwrapData = (response) => response?.data?.data || [];

export const createBuilderServices = () => ({
  async listBuilders({ siteId }) {
    return unwrapData(await axios.get(`${url}/builder/site/${siteId}`, authConfig()));
  },
  async getBuilder({ builderId }) {
    return unwrapData(await axios.get(`${url}/builder/${builderId}`, authConfig()));
  },
  async createBuilder({ payload }) {
    return unwrapData(await axios.post(`${url}/builder`, payload, authConfig()));
  },
  async updateBuilder({ builderId, payload }) {
    return unwrapData(await axios.put(`${url}/builder/${builderId}`, payload, authConfig()));
  },
  async deleteBuilder({ builderId }) {
    await axios.delete(`${url}/builder/${builderId}`, authConfig());
  },
  async listMedia({ siteId }) {
    return unwrapData(
      await axios.post(
        `${url}/media/filter`,
        { siteId, categoryId: 'all', type: 'published' },
        authConfig()
      )
    );
  },
  async listTemplates({ siteId }) {
    return unwrapData(
      await axios.post(`${url}/template/${siteId}`, { type: 'published' }, authConfig())
    );
  },
  async getTemplate({ siteId, templateId }) {
    return unwrapData(await axios.get(`${url}/template/${siteId}/${templateId}`, authConfig()));
  },
});

export const resolveBuilderMediaUrl = (media) => {
  if (!media) return null;
  if (media.mediaUrl?.startsWith('/uploads')) {
    return `${imgUrl}${media.mediaUrl.slice('/uploads'.length)}`;
  }
  if (media.mediaUrl) return media.mediaUrl;
  if (media.url) return media.url;
  if (media.logo) return `${imgUrl}/media/${media.logo}`;
  return null;
};
